module.exports = __webpack_public_path__ + "img/fdef4cb.webp";